import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Radio } from "lucide-react";
import { LANDING } from "@/constants/testIds";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const scrollTo = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
};

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#07030f]/80 backdrop-blur-xl border-b border-white/[0.06] py-3"
          : "bg-transparent py-6"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <div
          data-testid={LANDING.navLogo}
          className="flex items-center gap-2 cursor-pointer select-none"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <span className="relative flex h-8 w-8 items-center justify-center rounded-xl bg-gradient-to-br from-[#a259ff] via-[#c060ff] to-[#22d3ee] shadow-[0_0_20px_rgba(162,89,255,0.5)]">
            <Radio className="h-4 w-4 text-white" strokeWidth={2.5} />
          </span>
          <span className="font-display text-lg font-bold tracking-tight text-white">
            Geo<span className="text-[#a259ff]">Beats</span>
          </span>
        </div>

        <div className="hidden md:flex items-center gap-8 text-sm text-[#b9a9e6]">
          <button
            data-testid={LANDING.navFeaturesLink}
            onClick={() => scrollTo("features")}
            className="hover:text-white transition-colors"
          >
            Features
          </button>
          <button
            data-testid={LANDING.navHowItWorksLink}
            onClick={() => scrollTo("how-it-works")}
            className="hover:text-white transition-colors"
          >
            How it works
          </button>
          <a
            data-testid={LANDING.navSupportLink}
            href={`${BACKEND_URL}/api/support`}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition-colors"
          >
            Support
          </a>
        </div>

        <button
          data-testid={LANDING.navCtaButton}
          onClick={() => scrollTo("waitlist")}
          className="rounded-full bg-white text-[#0f0722] text-sm font-semibold px-5 py-2.5 hover:bg-[#22d3ee] hover:shadow-[0_0_24px_rgba(34,211,238,0.5)] transition-all duration-300"
        >
          Get Early Access
        </button>
      </div>
    </motion.nav>
  );
};
